module.exports = __webpack_public_path__ + "img/icon-34.01194cb6.png";